module.exports = __webpack_public_path__ + "img/2_275.1867f144.png";